<template>
    <div id="app">
        <HeaderIndex/>
        <div class="selectDive">
            <IndexSelect v-show="isIndexSelectShow"/>
        </div>
         <transition mode="out-in">
            <router-view></router-view>
        </transition>
        <Footer v-show="isFooterShow"/>
    </div>
</template>
<script>
    export default {
        name: 'App',
        data () {
            return {
                section: 'Head'
            }
        },
        computed: {
            isFooterShow () {
                return this.$store.state.isFooterShow
            },
            isIndexSelectShow () {
                return this.$store.state.isIndexSelectShow
            }
        },
        methods: {
            logout () {
                this.$store.commit('SET_USER', null)
                this.$store.commit('SET_TOKEN', null)

                if (window.localStorage) {
                    window.localStorage.setItem('user', null)
                    window.localStorage.setItem('token', null)
                }

                this.$router.push({name: 'login'})
            }
        },
        created () {
            let lang = 'zh-TW'
            if (localStorage.getItem('language') && localStorage.getItem('language') !== 'null') {
                this.$store.state.switchLanguage = localStorage.getItem('language')
                lang = localStorage.getItem('language')
            } else {
                localStorage.setItem('language', lang)
                this.$store.state.switchLanguage = localStorage.getItem('language')
            }
            this.$root.$i18n.locale = lang
            sessionStorage.setItem('isSideBarShow', 'start')
        },
        mounted () {
            if (localStorage.getItem('clickState')) {
                this.$store.state.borderStyle = localStorage.getItem('clickState')
            }
        }
    }
</script>
<style>
#app{
    background: none;
    width: 1280px;
    margin: 0 auto;
}
.row {
    margin: 0;
}
.selectDive{
    /* width: 1440px; */
    width: 1280px;
    margin: auto;
    position: relative;
}

.v-enter{
  opacity: 0;
}
.v-enter-active{
  transition: 0.8s;
}
.v-enter-to{
  opacity: 1;
}
.v-leave{
  opacity: 1;
}
.v-leave-to{
  opacity:0;
}
.v-leave-active{
  transition: 0.5s;
}

</style>



// WEBPACK FOOTER //
// App.vue?5badfaee